import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Time Series panel art: one measure tracked across seven periods, drawn as an
 * accent line with a soft area beneath it and a dotted zero baseline.
 */

const BASELINE = 82

/** Sampled points, left to right. */
const POINTS: [number, number][] = [
  [16, 66],
  [38, 56],
  [60, 60],
  [82, 44],
  [104, 48],
  [126, 32],
  [144, 26],
]

const LINE = POINTS.map(([x, y], index) => `${index === 0 ? 'M' : 'L'}${x} ${y}`).join(' ')
const AREA = `${LINE} L${POINTS[POINTS.length - 1][0]} ${BASELINE} L${POINTS[0][0]} ${BASELINE} Z`

export function TimeSeriesArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <path d={AREA} fill="hsl(var(--primary) / 0.15)" stroke="none" />
      <path
        d={`M12 ${BASELINE} H148`}
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.45)"
        strokeWidth="1.5"
        strokeDasharray="3 4"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d={LINE}
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {POINTS.map(([x, y]) => (
        <circle
          key={x}
          cx={x}
          cy={y}
          r={3}
          fill="hsl(var(--primary))"
          stroke="hsl(var(--card))"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
      ))}
    </svg>
  )
}
